module.exports = __webpack_public_path__ + "img/zc.db21f449.svg";